module.exports = __webpack_public_path__ + "static/media/logo no text white.b751f250.png";